import * as segmentationType from './segmentation-type';

// Same structure as we used in @bingads-webui/json-tree-parser
export const segmentationTree = [{
  name: 'None',
}, {
  name: 'Time',
  children: [{
    name: segmentationType.Day,
  }, {
    name: segmentationType.Week,
  }, {
    name: segmentationType.Month,
  }, {
    name: segmentationType.Quarter,
  }, {
    name: segmentationType.Year,
  }, {
    name: segmentationType.DayOfTheWeek,
  }, {
    name: segmentationType.DayOfWeek,
  }, {
    name: segmentationType.HourOfDay,
    permission: 'IsBAACompetitionEnabled',
  }],
}, {
  name: 'Audience',
  permission: 'IsAudienceSegmentationSupported',
  children: [{
    name: segmentationType.AudienceName,
  }, {
    name: segmentationType.AudienceType,
  }],
}, {
  name: 'Goal',
  permission: 'IsSegmentationGoalTypeSupported',
  children: [{
    name: segmentationType.GoalName,
  }, {
    name: segmentationType.GoalType,
  }, {
    name: segmentationType.GoalCategory,
  }],
}, {
  name: segmentationType.DeviceType,
}, {
  name: segmentationType.Device,
}, {
  name: segmentationType.Network,
}, {
  name: segmentationType.TopVsOther,
}, {
  name: segmentationType.AdScenario,
  permission: 'IsVerticalAdsReportingPhase1Enabled',
}];
